import * as React from 'react';
import { Elements } from 'prismic-reactjs';
import { HeaderItem } from '@components/vitals/utils/helpers';

interface PrismicHTMLSerializerProps {
  headersList: HeaderItem[];
}

/**
 * Custom serializer for hyperlinks in Prismic rich text fields.
 * Converts hyperlinks to `LinkTranslated`, enhancing them with attribute
 * like `targetBlank` when applicable.
 *
 * @param {Elements} type - The element type to be serialized.
 * @param {any} element - The element data in the format that makes sense for the type.
 * @returns {React.ReactNode} The serialized HTML element.
 */
const PrismicHTMLSerializer = ({ headersList }: PrismicHTMLSerializerProps) => {
  // eslint-disable-next-line consistent-return
  return (type: Elements, element: any) => {
    if (type === Elements.heading1 || type === Elements.heading2) {
      const { text } = element;
      const id = setupHeaderId(text, headersList);

      const Component = type === Elements.heading1 ? 'h1' : 'h2';
      return <Component id={id}>{text}</Component>;
    }
  };
};

export default PrismicHTMLSerializer;

const setupHeaderId = (text: string, headers: HeaderItem[]) => {
  const headerExists = headers.find((header) => header.text === text);
  return headerExists ? headerExists.id : '';
};
